export class PasswordWrapper extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    this.eyeIcon?.addEventListener('click', this.toggleEye.bind(this));
  }

  toggleEye(e) {
    const { target } = e;
    let control = null;
    if (target instanceof SVGElement) {
      control = target.closest('span');
    } else {
      control = target;
    }

    if (!control) return;
    
    if (control.hasAttribute('open')) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    const control = this.eyeIcon;
    if (!control) return;
    control.setAttribute('open', 'true');
    this.passwordInput.setAttribute('type', 'text');
  }

  close() {
    const control = this.eyeIcon;
    if (!control) return;
    control.removeAttribute('open');
    this.passwordInput.setAttribute('type', 'password');
  }

  get eyeIcon() {
    return this.querySelector('[ref="eyeIcon"]');
  }

  get passwordInput() {
    return this.querySelector('[ref="passwordInput"]');
  }
}

if (!customElements.get('password-wrapper')) {
  customElements.define('password-wrapper', PasswordWrapper);
}